import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import ScrollToTop from "./components/Layout/ScrollToTop";
import useCanonicalUrl from './components/UseCanonicalUrl/useCanonicalUrl';
import Home from "./Pages/Home";
import About from "./Pages/About";
import LoanPrograms from "./Pages/LoanPrograms";
import Contact from "./Pages/Contact";
import Testimonials from "./Pages/Testimonials";
import Sitemap from "./Pages/Sitemap/index";
import ErrorPage from "./components/ErrorPage/ErrorPage";
import "./App.css";
import { CookieSetting } from "cookiesetting-component";

function App() {
  const canonicalUrl = useCanonicalUrl();
  return (
    <React.Fragment>
      <Layout>
        <link rel="canonical" href={canonicalUrl} />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/why-evolutionai" element={<About />} />
          <Route path="/loan-programs" element={<LoanPrograms />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/sitemap" element={<Sitemap />} />
          {/* Error page route */}
          <Route path="/error" element={<ErrorPage />} />
          {/* Catch-all route for undefined paths */}
          <Route path="*" element={<Navigate to="/error" />} />
        </Routes>
      </Layout>
      <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
        />
    </React.Fragment>
  );
}
export default App;
